import Vue from 'vue';

import { initialState } from './state';
import StoreModuleService from '../StoreModuleService';

// mutations declarations
export const SET_ANALYTICS_PROVIDERS = 'SET_ANALYTICS_PROVIDERS';
export const SET_ANALYTICS_CONFIGURATIONS = 'SET_ANALYTICS_CONFIGURATIONS';
export const SET_ANALYTICS_CONFIGURATION = 'SET_ANALYTICS_CONFIGURATION';
export const DELETE_ANALYTICS_CONFIGURATION = 'DELETE_ANALYTICS_CONFIGURATION';
export const ADD_ANALYTICS_CONFIGURATION = 'ADD_ANALYTICS_CONFIGURATION';

const createAnalyticsConfiguration = ({ Vue, state, configuration }) =>
	Vue.set(state.analyticsConfigurations, configuration.id, configuration);

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_ANALYTICS_PROVIDERS](state, { analyticsProviders }) {
		Vue.set(state, 'analyticsProviders', analyticsProviders);
	},
	[SET_ANALYTICS_CONFIGURATIONS](state, { analyticsConfigurations }) {
		Vue.set(state, 'analyticsConfigurations', analyticsConfigurations);
	},
	[SET_ANALYTICS_CONFIGURATION](state, { analyticsConfiguration }) {
		Vue.set(state.analyticsConfigurations, analyticsConfiguration.id, analyticsConfiguration);
	},
	[DELETE_ANALYTICS_CONFIGURATION](state, { analyticsConfigurationId }) {
		Vue.delete(state.analyticsConfigurations, analyticsConfigurationId);
	},
	[ADD_ANALYTICS_CONFIGURATION](state, { analyticsConfiguration }) {
		createAnalyticsConfiguration({ Vue, state, configuration: analyticsConfiguration });
	},
};

export default mutations;
